import useSWR from 'swr-0-5-6'
import urlcat from 'urlcat'
import { apirc } from '~/configs/apirc'

export type StkWeight = {
  [key: string]: {
    symbol: string
    percentage: number
  }
}

const fetcher = async (url: string) => {
  const res = await fetch(url)
  if (res.status >= 400) throw new Error()
  return res.json()
}

/** 股期商品近遠月分數 */
export const useStkWeightResource = (date?: string) => {
  const url = urlcat(apirc.unclassified.stkfutWeightURL.toString(), { date })

  const res = useSWR<StkWeight>(url, fetcher, {
    revalidateOnFocus: false,
    refreshInterval: 15000,
  })

  return {
    data: res.data ? res.data : [],
    isLoading: !res.data && !res.error,
  }
}
